import { postApi } from "../../../../controller/api"
import { getWithdrawStatistic } from "../../../../controller/api/statistic/withdraw"
import { API_CODE } from "../../../../controller/constants"

export const getAllFunc = async (cookies, method, from, to, phone, result, page, successCallback) => {
    const response = await getWithdrawStatistic(cookies.lottmekong, {
        from: from,
        to: to,
        phone: phone,
        method: method,
        result: result || 'ALL',
    }, page, 'APP')

    if (response) {
        successCallback(response)
    }
}

export const undo = async (cookie, id) => {
    const requestData = {
        id: id,
    }
    return await postApi(cookie, API_CODE.REVERT_INTERNAL_WITHDRAW, requestData)
}